// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-wrapper-new-license[data-v-6d9b6258]{max-width:714px}.st1[data-v-6d9b6258]{fill:#fff}.st0[data-v-6d9b6258]{fill:url(#SVGID_1_)}@media (min-width:600px){svg[data-v-6d9b6258]{width:70%}}", ""]);
// Exports
module.exports = exports;
